const e = "styles-module__amenities___vhHgB", t = "styles-module__amenity___1YeK4", s = "styles-module__expanded___It0Xw", _ = {
  amenities: e,
  "amenities-list": "styles-module__amenities-list___HFi4U",
  amenity: t,
  expanded: s,
  "show-more-button": "styles-module__show-more-button___C5V9R"
};
export {
  e as amenities,
  t as amenity,
  _ as default,
  s as expanded
};
